import { Directive } from '@angular/core';

@Directive({
	selector: 'Highcharts',
})
export class HighchartsDirective {}
